import { useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';

import palette from '../../../../theme/learnerPalette';
import AtomGrid from '../../../atoms/AtomGrid';
import { styleConfigs } from '../../../resources/styleConfigs';

export const ContainerStyled = styled(AtomGrid)(() => ({
  display: 'flex',
  alignItems: 'center',
  whiteSpace: 'nowrap',
  fontWeight: styleConfigs.fonts.weight600,
  fontSize: styleConfigs.fonts.fontSize16,
  color: palette.light.text.prussianBlue,
  padding: `${styleConfigs.marginPadding.custom5}px ${styleConfigs.marginPadding.custom12}px`,
  gap: styleConfigs.marginPadding.custom6,
  border: `${styleConfigs.borders.borderLine} ${palette.light.text.prussianBlue}`,
  borderRadius: styleConfigs.borders.radius50,
  [useTheme().breakpoints.down('md')]: {
    fontSize: styleConfigs.fonts.fontSize14,
    lineHeight: styleConfigs.fonts.empty,
  },
  [useTheme().breakpoints.down('sm')]: {
    fontSize: styleConfigs.fonts.fontSize12,
  },
}));
